<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 order-1 order-lg-2">
        <QuickActions />
      </div>
      <div id="myProjectsSection" class="col-lg-8 order-2 order-lg-1 border-right border-primary
      mb-2">
        <MyProjects />
      </div>
    </div>
     <MapCard
      :baseUrl="mapUrl"
      featureId=" "
      title="VOF Statewide"
      ref="mapCard"
      :defaultOpened="true"
    >
    </MapCard>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MyProjects from '../components/MyProjects.vue';
import QuickActions from '../components/QuickActions.vue';
import MapCard from '../components/common/MapCard.vue';


export default {
  name: 'Home',
  components: {
    MyProjects,
    QuickActions,
    MapCard,
  },
  created() {
    this.$store.dispatch('fetchConfiguration');
  },
  computed: {
    ...mapState({ mapUrl: state => state.Config.config.agolStateUrl }),
  },
};
</script>

<style scoped lang="scss">
@import '../../sass/base';

@include media-breakpoint-down(md) {
  #myProjectsSection {
    border: none!important;
  }
}
</style>
